<template>
  <div class="upload-slide-filelist">
    <rt-section
      :title="title"
      :icon="titleIcon"
    >
      <slot
        slot="btn"
        name="right-top"
      >
        <el-upload
          v-if="showButtons"
          slot="btn"
          :show-file-list="false"
          :http-request="uploadFile"
          class="addBtn"
          action
        >
          <rt-button
            icon-name="rt-base-plus"
            :color-type="iconColor"
          />
        </el-upload>
      </slot>
      <div
        v-if="data.length > 0"
        class="file-list"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          class="file-item"
        >
          <div class="file-icon">
            <rt-popover
              v-if="isImage(item.name)"
              popper-class="rt-upload-slide-image"
              placement="left"
              trigger="hover"
            >
              <rt-image-preview
                v-if="isImage(item.name)"
                :src="item.url"
                :preview-src-list="[item.url]"
              />
              <rt-icon
                v-else
                :name="fileIconName(item.name)"
                :color="fileIconName(item.name)"
                size="32"
              />
              <rt-image-preview
                v-if="isImage(item.name)"
                slot="reference"
                :src="item.url"
                :preview-src-list="[item.url]"
                style="width: 40px; height: 40px"
              />
              <rt-icon
                v-else
                slot="reference"
                :name="fileIconName(item.name)"
                :color="fileIconName(item.name)"
                size="32"
              />
            </rt-popover>
            <rt-icon
              v-else
              :name="fileIconName(item.name)"
              :color="fileIconColor(item.name)"
              size="32"
            />
          </div>
          <div class="file-detail">
            <p
              class="item-name"
              @click="itemClick(index)"
            >
              {{ item.name }}
            </p>
            <div
              v-if="item.size"
              class="item-size"
            >
              <span class="label">{{
                $tx('大小：', 'xpc.uploadfile.size')
              }}</span>{{ fileSize(item.size) }}
            </div>
            <div class="uploadTime-and-operation">
              <span class="time">{{ item.uploadTime }}</span>
              <div class="operation">
                <!-- <rt-button
                  v-if="
                    ['jpg', 'png', 'jpeg'].indexOf(fileSuffix(item.name)) > -1
                  "
                  text
                  type="plain"
                  @click="previewImg(item.url)"
                  >预览</rt-button
                > -->
                <rt-button
                  v-if="showDownload"
                  text
                  type="plain"
                  @click="downloadClick(index)"
                >
                  {{ $tx('下载', 'xpc.uploadfile.download') }}
                </rt-button>
                <rt-popconfirm
                  v-if="showDelete"
                  :title="
                    $tx(
                      '确定需要删除这条内容吗？',
                      'xpc.uploadfile.confirmdelete'
                    )
                  "
                  @confirm="onConfirm(item.name, index)"
                >
                  <rt-button
                    slot="reference"
                    text
                    type="plain"
                  >
                    {{ $tx('删除', 'xpc.uploadfile.delete') }}
                  </rt-button>
                </rt-popconfirm>
              </div>
            </div>
          </div>
        </div>
      </div>
      <slot
        v-else
        name="empty"
      >
        <rt-default-image>
          <div slot="describe">
            {{ $tx('暂无数据', 'xpc.uploadfile.nodata') }}
          </div>
        </rt-default-image>
      </slot>
    </rt-section>
    <el-dialog :visible.sync="imgVisible">
      <img :src="previewUrl" />
    </el-dialog>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtSection from '../section/rtSection';
import RtButton from '../button/rtButton';
import RtPopconfirm from '../popconfirm/rtPopconfirm';
import RtDefaultImage from '../defaultImage/rtDefaultImage';
export default {
  name: 'RtUploadSlideFilelist',
  components: {
    RtIcon,
    RtSection,
    RtButton,
    RtPopconfirm,
    RtDefaultImage
  },
  props: {
    title: {
      type: String,
      default () {
        return this.$tx('文件列表', 'xpc.uploadfile.filelist');
      }
    },
    iconColor: {
      type: String,
      default: 'neutral-placeholder'
    },
    data: {
      type: Array,
      default: () => []
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    uploadFileFn: {
      type: Function
    },
    titleIcon: {
      type: String,
      default: 'rt-base-orders_fill'
    }
  },
  data () {
    return {
      list: this.data,
      currentIndex: 0,
      imgVisible: false,
      previewUrl: ''
    };
  },
  watch: {
    data (newValue) {
      this.$nextTick(() => {
        this.list = JSON.parse(JSON.stringify(newValue));
      });
    }
  },
  methods: {
    downloadClick (index) {
      this.$emit('item-download', index, this.data[index]);
    },
    itemClick (index) {
      this.$emit('item-click', index, this.data[index]);
    },
    uploadFile (file) {
      let now = new Date();
      let [month, date, hour, minute] = ['', ''];
      month = now.getMonth() + 1;
      date = now.getDate();
      hour = now.getHours();
      minute = now.getMinutes();
      let fileName = file.file.name;

      if (this.$xpc.isFunction(this.uploadFileFn)) {
        this.uploadFileFn(file)
          .then(({ url }) => {
            this.list.push({
              url,
              name: fileName,
              uploadTime: `${month}-${date} ${hour}:${minute}`
            });
          })
          .catch(() => {
            this.uploadFlag = false;
          });
      }
    },
    // 删除确认事件
    onConfirm (name, index) {
      this.$emit('item-delete', index, this.data[index]);
    },
    previewImg (url) {
      this.imgVisible = true;
      this.previewUrl = url;
    },
    // 取文件后缀名
    fileSuffix (name) {
      return name.substring(name.lastIndexOf('.') + 1).toLowerCase();
    },
    isImage (name) {
      return rt.isImageFile(this.fileSuffix(name));
    },
    // 根据文件后缀名显示对应的icon
    fileIconName (name) {
      const fileIconInfo = rt.getFileIconInfo(this.fileSuffix(name));
      return fileIconInfo && fileIconInfo.iconName;
    },
    // 根据文件后缀名显示对应的颜色值
    fileIconColor (name) {
      const fileIconInfo = rt.getFileIconInfo(this.fileSuffix(name));
      return fileIconInfo && fileIconInfo.iconColor;
    },
    // 文件大小 —— 用文件大小 / 1024，如果小于1024，显示 M，如果大于1024，再 / 1024，显示 G
    // 用Math.round(size * 100) / 100 四舍五入保留2位小数
    fileSize (size) {
      // 这里的size是比特单位
      let sizeKB = size / 1024;
      if (sizeKB >= 1024) {
        if (sizeKB / 1024 > 1024) {
          return (
            (Math.round((sizeKB / 1024 / 1024) * 100) / 100).toFixed(2) + 'G'
          );
        } else {
          return (Math.round((sizeKB / 1024) * 100) / 100).toFixed(2) + 'M';
        }
      } else {
        return sizeKB.toFixed(2) + 'K';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtUploadSlideFile.vue?02212242